import { render, staticRenderFns } from "./Detalle-nota-de-pedido.vue?vue&type=template&id=47e373aa&scoped=true"
import script from "./Detalle-nota-de-pedido.vue?vue&type=script&lang=js"
export * from "./Detalle-nota-de-pedido.vue?vue&type=script&lang=js"
import style0 from "./Detalle-nota-de-pedido.vue?vue&type=style&index=0&id=47e373aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e373aa",
  null
  
)

export default component.exports